import { Component, Host, h, Prop, State, Event, EventEmitter, Listen } from '@stencil/core';
import { localizeNumbers } from '../../utils/utils';

@Component({
	tag: 'afs-donation-price-point',
	styleUrl: 'afs-donation-price-point.scss',
	shadow: false,
	scoped: true
})

export class AfsDonationPricePoint {
    
    @Prop() backgroundColor : string = "transparent";
    @Prop() mainColor : string = "coral";
    @Prop() contrastColor : string = "#FFF";
    
    @Prop() price : number = 2;
    @Prop() hrefFragment : string = "";
    
    @State() isSelected : boolean = false;

	@Event() donationSelected: EventEmitter;
	donationSelectedHandler() {
		this.isSelected = true;

		this.donationSelected.emit({
			price: this.price,
			hrefFragment: this.hrefFragment,
			quantity: 1
		});
	}

	@Event() donationDeselected: EventEmitter;
	donationDeselectedHandler() {
		this.isSelected = false;

		this.donationDeselected.emit();
	}

	@Listen('donationUpdateSelection', { target: "window" })
	donationUpdateSelectionHandler(e) {
        this.isSelected = !e.detail || e.detail.price !== this.price ? false : true;
	}

	@Listen('raffleCartEmptied', { target: 'window' })
	allTicketsRemovedhandler() {
		this.donationDeselectedHandler();
	};

	render() {
		return (
			<Host style={{
				position: 'relative'
			}}>
				<afs-button
					background-color={this.isSelected ? this.mainColor : this.backgroundColor}
					border-color={this.isSelected ? this.backgroundColor : this.mainColor}
					color={this.isSelected ? this.contrastColor : this.mainColor} 
					rounded-edge size='l' width='110px'
					onClick={() => this.isSelected ? this.donationDeselectedHandler() : this.donationSelectedHandler()}
				>
					{this.isSelected && 
                    <div class='check-container' style={{ backgroundColor: this.contrastColor }}>
                        <span class='check' style={{ borderColor: this.mainColor }}></span>
                    </div>}
					<span class='price'>{localizeNumbers(this.price, true)}</span>
				</afs-button>
			</Host>
		)
	}

}
